export const SearchTrendsCard = {
  name: 'SearchTrendsCard',
  props: {
    keyword: {
      type: String,
      default: 'pressure washing'
    },
    geo: {
      type: String,
      default: 'US-FL'
    },
    title: {
      type: String,
      default: 'Demand'
    },
    height: {
      type: String,
      default: 'h-100'
    }
  },
  data() {
    return {
      searchTrends: {
        loading: false,
        error: null,
        lastUpdated: null,
        selectedPeriod: '30d',
        data: {
          pressureWashing: {
            currentVolume: 0,
            change: 0,
            trend: 'stable',
            hasData: false,
            dataSource: 'Google Trends API'
          },
          topKeywords: [],
          hasKeywordData: false,
          competitorAnalysis: {
            avgPosition: 'N/A - Insufficient data',
            opportunities: 'N/A - Insufficient data',
            note: 'Competitive analysis requires additional data sources'
          },
          seasonalInsights: {
            peakMonths: ['March', 'April', 'May', 'October'],
            currentSeason: 'normal',
            note: 'Based on industry patterns'
          }
        }
      }
    };
  },
  computed: {
    cardId() {
      return `trends-card-${this._uid}`;
    }
  },
  methods: {
    async fetchSearchTrends() {
      this.searchTrends.loading = true;
      this.searchTrends.error = null;
      
      try {
        // Dummy response to save API calls
        const dummyResponse = {
          data: {
            contents: JSON.stringify({
              "search_metadata": {
                "id": "68ccd39103610a375f80e4c5",
                "status": "Success",
                "json_endpoint": "https://serpapi.com/searches/e5b4f9f2b557afcc/68ccd39103610a375f80e4c5.json",
                "created_at": "2025-09-19 03:52:49 UTC",
                "processed_at": "2025-09-19 03:52:49 UTC",
                "google_trends_url": "https://trends.google.com/trends/embed/explore/TIMESERIES?hl=en&tz=420&req=%7B%22comparisonItem%22%3A%5B%7B%22keyword%22%3A%22pressure+washing%22%2C%22geo%22%3A%22US-FL%22%2C%22time%22%3A%22today+1-m%22%7D%5D%2C%22category%22%3A0%2C%22property%22%3A%22%22%7D",
                "raw_html_file": "https://serpapi.com/searches/e5b4f9f2b557afcc/68ccd39103610a375f80e4c5.html",
                "prettify_html_file": "https://serpapi.com/searches/e5b4f9f2b557afcc/68ccd39103610a375f80e4c5.prettify",
                "total_time_taken": 1.04
              },
              "search_parameters": {
                "engine": "google_trends",
                "q": "pressure washing",
                "hl": "en",
                "geo": "US-FL",
                "date": "today 1-m",
                "tz": "420",
                "data_type": "TIMESERIES"
              },
              "interest_over_time": {
                "timeline_data": [
                  {
                    "date": "Aug 19, 2025",
                    "timestamp": "1755561600",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "76",
                        "extracted_value": 76
                      }
                    ]
                  },
                  {
                    "date": "Aug 20, 2025",
                    "timestamp": "1755648000",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "85",
                        "extracted_value": 85
                      }
                    ]
                  },
                  {
                    "date": "Aug 21, 2025",
                    "timestamp": "1755734400",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "57",
                        "extracted_value": 57
                      }
                    ]
                  },
                  {
                    "date": "Aug 22, 2025",
                    "timestamp": "1755820800",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "65",
                        "extracted_value": 65
                      }
                    ]
                  },
                  {
                    "date": "Aug 23, 2025",
                    "timestamp": "1755907200",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "49",
                        "extracted_value": 49
                      }
                    ]
                  },
                  {
                    "date": "Aug 24, 2025",
                    "timestamp": "1755993600",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "53",
                        "extracted_value": 53
                      }
                    ]
                  },
                  {
                    "date": "Aug 25, 2025",
                    "timestamp": "1756080000",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "99",
                        "extracted_value": 99
                      }
                    ]
                  },
                  {
                    "date": "Aug 26, 2025",
                    "timestamp": "1756166400",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "75",
                        "extracted_value": 75
                      }
                    ]
                  },
                  {
                    "date": "Aug 27, 2025",
                    "timestamp": "1756252800",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "85",
                        "extracted_value": 85
                      }
                    ]
                  },
                  {
                    "date": "Aug 28, 2025",
                    "timestamp": "1756339200",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "63",
                        "extracted_value": 63
                      }
                    ]
                  },
                  {
                    "date": "Aug 29, 2025",
                    "timestamp": "1756425600",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "65",
                        "extracted_value": 65
                      }
                    ]
                  },
                  {
                    "date": "Aug 30, 2025",
                    "timestamp": "1756512000",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "50",
                        "extracted_value": 50
                      }
                    ]
                  },
                  {
                    "date": "Aug 31, 2025",
                    "timestamp": "1756598400",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "60",
                        "extracted_value": 60
                      }
                    ]
                  },
                  {
                    "date": "Sep 1, 2025",
                    "timestamp": "1756684800",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "58",
                        "extracted_value": 58
                      }
                    ]
                  },
                  {
                    "date": "Sep 2, 2025",
                    "timestamp": "1756771200",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "82",
                        "extracted_value": 82
                      }
                    ]
                  },
                  {
                    "date": "Sep 3, 2025",
                    "timestamp": "1756857600",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "100",
                        "extracted_value": 100
                      }
                    ]
                  },
                  {
                    "date": "Sep 4, 2025",
                    "timestamp": "1756944000",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "63",
                        "extracted_value": 63
                      }
                    ]
                  },
                  {
                    "date": "Sep 5, 2025",
                    "timestamp": "1757030400",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "73",
                        "extracted_value": 73
                      }
                    ]
                  },
                  {
                    "date": "Sep 6, 2025",
                    "timestamp": "1757116800",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "65",
                        "extracted_value": 65
                      }
                    ]
                  },
                  {
                    "date": "Sep 7, 2025",
                    "timestamp": "1757203200",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "58",
                        "extracted_value": 58
                      }
                    ]
                  },
                  {
                    "date": "Sep 8, 2025",
                    "timestamp": "1757289600",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "79",
                        "extracted_value": 79
                      }
                    ]
                  },
                  {
                    "date": "Sep 9, 2025",
                    "timestamp": "1757376000",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "72",
                        "extracted_value": 72
                      }
                    ]
                  },
                  {
                    "date": "Sep 10, 2025",
                    "timestamp": "1757462400",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "74",
                        "extracted_value": 74
                      }
                    ]
                  },
                  {
                    "date": "Sep 11, 2025",
                    "timestamp": "1757548800",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "61",
                        "extracted_value": 61
                      }
                    ]
                  },
                  {
                    "date": "Sep 12, 2025",
                    "timestamp": "1757635200",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "78",
                        "extracted_value": 78
                      }
                    ]
                  },
                  {
                    "date": "Sep 13, 2025",
                    "timestamp": "1757721600",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "80",
                        "extracted_value": 80
                      }
                    ]
                  },
                  {
                    "date": "Sep 14, 2025",
                    "timestamp": "1757808000",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "67",
                        "extracted_value": 67
                      }
                    ]
                  },
                  {
                    "date": "Sep 15, 2025",
                    "timestamp": "1757894400",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "82",
                        "extracted_value": 82
                      }
                    ]
                  },
                  {
                    "date": "Sep 16, 2025",
                    "timestamp": "1757980800",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "76",
                        "extracted_value": 76
                      }
                    ]
                  },
                  {
                    "date": "Sep 17, 2025",
                    "timestamp": "1758067200",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "74",
                        "extracted_value": 74
                      }
                    ]
                  },
                  {
                    "date": "Sep 18, 2025",
                    "timestamp": "1758153600",
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "61",
                        "extracted_value": 61
                      }
                    ]
                  },
                  {
                    "date": "Sep 19, 2025",
                    "timestamp": "1758240000",
                    "partial_data": true,
                    "values": [
                      {
                        "query": "pressure washing",
                        "value": "46",
                        "extracted_value": 46
                      }
                    ]
                  }
                ]
              }
            })
          }
        };

        // Use dummy response instead of API call
        const response = dummyResponse;
        
        // Commented out actual API call to save on limits
        /*
        const serpApiKey = '3bee4b56359f50a8d713a8a2dcd7b6143b7f6cc92c445ed275fc58cb01564f21';
        const proxyUrl = 'https://api.allorigins.win/get?url=';
        const timeframe = this.convertPeriodToTimeframe(this.searchTrends.selectedPeriod);
        
        const serpApiUrl = 'https://serpapi.com/search.json';
        const params = new URLSearchParams({
          engine: 'google_trends',
          q: this.keyword,
          geo: this.geo,
          date: timeframe,
          api_key: serpApiKey
        });
        
        const fullUrl = `${serpApiUrl}?${params}`;
        const encodedUrl = encodeURIComponent(fullUrl);
        
        const response = await axios.get(`${proxyUrl}${encodedUrl}`);
        */
        
        const data = JSON.parse(response.data.contents);
        
        this.processSearchTrendsData(data, null);
        this.searchTrends.lastUpdated = new Date();
        
      } catch (error) {
        console.error('Error fetching search trends:', error);
        this.searchTrends.error = `Unable to load trends data: ${error.message}`;
      } finally {
        this.searchTrends.loading = false;
      }
    },

    processSearchTrendsData(mainData, relatedData) {
      let currentVolume = 0;
      let change = 0;
      let trend = 'stable';
      let hasValidData = false;
      
      if (mainData.interest_over_time && mainData.interest_over_time.timeline_data) {
        const timelineData = mainData.interest_over_time.timeline_data;
        
        if (timelineData.length >= 2) {
          const latestPoint = timelineData[timelineData.length - 1];
          const previousPoint = timelineData[timelineData.length - 2];
          
          if (latestPoint && latestPoint.values && latestPoint.values[0]) {
            currentVolume = latestPoint.values[0].extracted_value || 0;
            hasValidData = true;
            
            if (previousPoint && previousPoint.values && previousPoint.values[0]) {
              const previousVolume = previousPoint.values[0].extracted_value || 0;
              
              if (previousVolume > 0) {
                change = ((currentVolume - previousVolume) / previousVolume) * 100;
              } else if (currentVolume > 0) {
                change = 100;
              }
              
              trend = change > 5 ? 'up' : change < -5 ? 'down' : 'stable';
            }
          }
        }
      }
      
      const topKeywords = [];
      let hasKeywordData = false;
      
      if (relatedData && relatedData.related_queries) {
        if (relatedData.related_queries.rising && relatedData.related_queries.rising.length > 0) {
          relatedData.related_queries.rising.slice(0, 5).forEach(item => {
            topKeywords.push({
              term: item.query,
              volume: item.extracted_value ? `${item.extracted_value}% interest` : 'Low volume',
              difficulty: 'N/A - Trends data'
            });
          });
          hasKeywordData = true;
        }
      }
      
      this.searchTrends.data = {
        pressureWashing: {
          currentVolume: currentVolume,
          change: Math.round(change * 10) / 10,
          trend: trend,
          hasData: hasValidData,
          dataSource: 'Google Trends API'
        },
        topKeywords: topKeywords,
        hasKeywordData: hasKeywordData,
        competitorAnalysis: {
          avgPosition: 'N/A - Insufficient data',
          opportunities: 'N/A - Insufficient data',
          note: 'Competitive analysis requires additional data sources'
        },
        seasonalInsights: {
          peakMonths: ['March', 'April', 'May', 'October'],
          currentSeason: this.getCurrentSeason(),
          note: 'Based on industry patterns'
        }
      };
    },

    convertPeriodToTimeframe(period) {
      switch (period) {
        case '7d': return 'now 7-d';
        case '30d': return 'today 1-m';
        case '90d': return 'today 3-m';
        default: return 'today 1-m';
      }
    },

    updateSearchTrendsPeriod(period) {
      this.searchTrends.selectedPeriod = period;
      this.fetchSearchTrends();
    },

    getCurrentSeason() {
      const month = new Date().getMonth() + 1;
      if (month >= 3 && month <= 5) return 'peak';
      if (month >= 6 && month <= 9) return 'high';
      if (month >= 10 && month <= 11) return 'normal';
      return 'low';
    },

    getTrendIcon(trend) {
      switch(trend) {
        case 'up': return 'bi-arrow-up text-success';
        case 'down': return 'bi-arrow-down text-danger';
        default: return 'bi-arrow-right text-warning';
      }
    },

    getSeasonBadgeClass(season) {
      const classes = {
        'peak': 'alert-success',
        'high': 'alert-primary', 
        'normal': 'alert-secondary',
        'low': 'alert-warning'
      };
      return classes[season] || 'alert-secondary';
    },

    formatTime(date) {
      if (!date) return '';
      const dateObj = date instanceof Date ? date : new Date(date);
      if (isNaN(dateObj.getTime())) return 'Invalid date';
      return dateObj.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
      });
    }
  },
  
  mounted() {
    this.fetchSearchTrends();
  },
  
  template: '#search-trends'
};
